export enum DataAccessSecurityErrorCodes {
  SESSION_EXPIRED = 1001,
  LOGIN_SESSION_EXPIRED = 1002,
  NO_PRINCIPAL = 1003,
  LOGOUT_INCOMPLETE = 1004,
  UNAUTHORIZED = 401,
}
